var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { property } from 'lit/decorators.js';
import { html, css } from 'lit';
import { stringDecoder, customElement, PICBase } from '../Internals';
let PICFile = class PICFile extends PICBase {
    constructor() {
        super();
    }
    static get styles() {
        const defaultStyle = css `

        `;
        return css `
            ${super.styles}
            ${defaultStyle}
        `;
    }
    focus() {
    }
    get submitValue() {
        return null;
    }
    validateSubmit() {
        return true;
    }
    connectedCallback() {
        super.connectedCallback();
    }
    renderThumb(iLocation) {
        return html `<img src=${iLocation}>`;
    }
    renderImage() {
        return html `<a href=${this.down_} target="_blank">${this.renderThumb(this.thumb_)}</a>`;
    }
    renderDoc() {
        return html ``;
    }
    renderLink() {
        return html `<a href=${this.down_} target="_blank">${this.name_}</a>`;
    }
    render() {
        const part1 = html `${this.renderCSS(true)}<div class="container">`;
        const part2 = html `</div>`;
        switch (this.type_) {
            case 'image':
                return html `${part1}${this.renderImage()}${part2}`;
                break;
            case 'doc':
                return html `${part1}${this.renderLink()}${part2}`;
                break;
            case 'pdf':
                return html `${part1}${this.renderLink()}${part2}`;
                break;
            default:
                return html `${part1}${this.renderLink()}${part2}`;
                break;
        }
    }
};
__decorate([
    property({ converter: stringDecoder, attribute: 'down' })
], PICFile.prototype, "down_", void 0);
__decorate([
    property({ converter: stringDecoder, attribute: 'name' })
], PICFile.prototype, "name_", void 0);
__decorate([
    property({ converter: stringDecoder, attribute: 'thumb' })
], PICFile.prototype, "thumb_", void 0);
__decorate([
    property({ converter: stringDecoder, attribute: 'type' })
], PICFile.prototype, "type_", void 0);
PICFile = __decorate([
    customElement('pic-file')
], PICFile);
export { PICFile };
//# sourceMappingURL=PICFile.js.map